import { render, staticRenderFns } from "./Update-Department.vue?vue&type=template&id=47b99bd2&scoped=true&"
import script from "./Update-Department.vue?vue&type=script&lang=js&"
export * from "./Update-Department.vue?vue&type=script&lang=js&"
import style0 from "./Update-Department.vue?vue&type=style&index=0&id=47b99bd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b99bd2",
  null
  
)

export default component.exports